<template>
  <div>
    <div class="cover">
      <imageContainer class="image"
                      :imageName="'SZY_9773'"
                      :width="'100%'"
                      :height="'100vh'"></imageContainer>
      <h1 class="title">Kísérő<br>Programok</h1>
      <div @click="goToSection('#program-list')" class="arrow">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <program-list :programList="programList" v-if="programs" :extra="true"></program-list>
  </div>
</template>

<script>
  import ProgramList from '../components/programlist'
  import { scrollToSection } from '../utils'
  import ArrowSvg from '../components/arrow'
  import ImageContainer from '../components/imageContainer'
  import { sortProgramsByDate, reducePrograms } from '../utils'

  export default {
    name: 'extraPrograms',
    components: {ProgramList, ArrowSvg, ImageContainer},
    computed: {
      programs () {
        return this.$store.state.companies.programs
      },
      programList () {
        return this.programs
          .sort(sortProgramsByDate)
          .filter(i => i.type === 'kisero')
          .reduce(reducePrograms, {})
      }
    },
    methods: {
      goToSection (selector) {
        return scrollToSection(selector)
      }
    },
    mounted () {
      this.$store.dispatch('companies/getPrograms')
    }
  }
</script>

<style scoped>
  .cover {
    color: white;
    position: relative;
    height: 100vh;
    background: white;
  }

  .image {
    opacity: 0.8;
  }

  .cover h1, .cover h2 {
    position: absolute;
  }

  .cover h1 {
    right: 60px;
    top: 25vh;
    margin-bottom: 10px;
    text-align: right;
    font-size: 70px;
    color: var(--colorA);
    text-transform: uppercase;
    text-shadow: 2px 2px white;
  }

  @media (max-height: 500px) {
    .cover h1 {
      font-size: 96px;
    }
  }

  @media (max-width: 600px) {
    .cover h1 {
      top: 22vh;
      right: 20px;
      font-size: 12vw;
      line-height: 1.2;
    }
  }

  .arrow {
    position: absolute;
    bottom: 7vh;
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
    padding: 5px;
    font-size: 36px;
    color: var(--colorA);
    cursor: pointer;
    z-index: 2;
    border: 2px solid var(--colorA);
    box-sizing: border-box;
  }
</style>
